module.exports = __webpack_public_path__ + "img/magic-wand-active.f2a17de9.svg";